// Wait for ModalDialog to be available
(function() {
  function initProductImageModal() {
    if (typeof ModalDialog === 'undefined') {
      setTimeout(initProductImageModal, 50);
      return;
    }

    if (!customElements.get('product-image-modal')) {
      customElements.define(
        'product-image-modal',
        class ProductImageModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;

        if (this.closest('.shopify-section')) {
          this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
        }

        document.body.appendChild(this);
        
        // Find modalContent after element is moved to body
        this.modalContent = this.querySelector('[id^="ProductImageModalInfo-"]');
        
        if (!this.modalContent) {
          console.error('ProductImageModalInfo element not found in', this);
        }

        this.addEventListener('product-info:loaded', ({ target }) => {
          if (target && typeof target.addPreProcessCallback === 'function') {
            target.addPreProcessCallback(this.preprocessHTML.bind(this));
          }
        });
      }

      hide(preventFocus = false) {
        publish(PUB_SUB_EVENTS.modalToggle,  { display: true });
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        
        if (this.modalContent) {
          this.modalContent.innerHTML = '';
        }

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        publish(PUB_SUB_EVENTS.modalToggle,  { display: false });
        
        // Ensure modalContent is set
        if (!this.modalContent) {
          this.modalContent = this.querySelector('[id^="ProductImageModalInfo-"]');
        }
        
        if (!this.modalContent) {
          console.error('Modal content element not found');
          return;
        }
        
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            
            // Store the full responseHTML for accessing sections outside product-info
            this.fullResponseHTML = responseHTML;

            if (!productElement) {
              console.error('Product element not found in response');
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              const spinner = opener.querySelector('.loading__spinner');
              if (spinner) spinner.classList.add('hidden');
              return;
            }

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);


            // Add copy codes block from timer section
            this.addCopyCodesBlock(this.fullResponseHTML || responseHTML);
            
            // Add gift picker if it exists
            this.addGiftPicker(responseHTML);


            this.addAdditionalSections(responseHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            const spinner = opener.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        if (!productElement || !productElement.classList) {
          return;
        }
        
        if (!this.modalContent) {
          console.error('Modal content not found');
          return;
        }
        
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        if (!productElement) return;
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        if (!productElement) return;
        
        // Remove elements that shouldn't appear in modals
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
        
        // Add class="product-image-modal-hide" to any element in product templates to hide it
        const hiddenFromImageModalElements = productElement.querySelectorAll('.product-image-modal-hide');
        if (hiddenFromImageModalElements) hiddenFromImageModalElements.forEach((el) => el.remove());

        const productTabs = productElement.querySelectorAll('.product-modal-drawer__opener');
        if (productTabs) productTabs.forEach((tab) => tab.remove());

        const svgIcons = productElement.querySelectorAll('.svg-icons__wrapper');
        if (svgIcons) svgIcons.forEach((icon) => icon.remove());
      }

      preventDuplicatedIDs(productElement) {
        if (!productElement || !productElement.dataset) {
          return;
        }
        
        const sectionId = productElement.dataset.section;
        if (!sectionId) {
          return;
        }

        const oldId = sectionId;
        const newId = `-product-image-modal-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        if (!productElement) return;
        
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        if (!productElement) return;
        
        const product = productElement.querySelector('.product');
        if (!product) return;
        
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      addGiftPicker(responseHTML) {
        if (!this.modalContent || !responseHTML) return;

        // Check if gift picker already exists in the modal content
        const existingGiftPicker = this.modalContent.querySelector('gift-swatches');
        if (existingGiftPicker) {
          // Gift picker is already in the content, ensure it's visible and has the quick-add-show class
          if (!existingGiftPicker.classList.contains('quick-add-show')) {
            existingGiftPicker.classList.add('quick-add-show');
          }
          return;
        }

        // Try to find gift picker in the fetched HTML
        // It should be in the buy-buttons section within product-info
        const productInfo = responseHTML.querySelector('product-info');
        if (!productInfo) return;

        const giftPicker = productInfo.querySelector('gift-swatches');
        if (!giftPicker) return;

        // Clone the gift picker
        const giftPickerClone = giftPicker.cloneNode(true);

        // Ensure it has the quick-add-show class to be visible
        if (!giftPickerClone.classList.contains('quick-add-show')) {
          giftPickerClone.classList.add('quick-add-show');
        }

        // Find where to insert it - should be before the product form (matching buy-buttons structure)
        const productForm = this.modalContent.querySelector('product-form');
        if (productForm && productForm.parentNode) {
          // Insert before the product form to match buy-buttons.liquid structure
          productForm.parentNode.insertBefore(giftPickerClone, productForm);
        } else {
          // If no product form found, append to modal content
          this.modalContent.appendChild(giftPickerClone);
        }

        // The custom element should auto-initialize when added to the DOM
        // Custom elements automatically call connectedCallback when inserted
      }

      addCopyCodesBlock(responseHTML) {
        if (!this.modalContent) return;

        // The timer section is on the current page (collection page), not in the fetched product page
        // So we need to search in the current document, not in responseHTML
        let copyCodesElement = document.querySelector('.timer__custom_wrapper .timer-code__wrapper copy-codes');
        
        // If not found, try to find it in timer__custom_wrapper directly
        if (!copyCodesElement) {
          copyCodesElement = document.querySelector('.timer__custom_wrapper copy-codes');
        }

        // If still not found, try to find it in product-info on current page
        if (!copyCodesElement) {
          const productInfo = document.querySelector('product-info');
          if (productInfo) {
            copyCodesElement = productInfo.querySelector('copy-codes');
          }
        }

        // If still not found, try to find any copy-codes element on current page
        if (!copyCodesElement) {
          copyCodesElement = document.querySelector('copy-codes');
        }

        if (!copyCodesElement) {
          console.log('Copy codes element not found in timer section on current page');
          return;
        }

        // Check if copy codes already exists in modal
        const existingCopyCodes = this.modalContent.querySelector('copy-codes');
        if (existingCopyCodes) {
          // Already exists, ensure it's visible
          const wrapper = existingCopyCodes.closest('.copy-codes__wrapper') || existingCopyCodes.closest('.timer-code__wrapper');
          if (wrapper) {
            wrapper.style.display = 'flex';
          }
          return;
        }

        // Clone the copy-codes element
        const copyCodesClone = copyCodesElement.cloneNode(true);

        // Create a wrapper if needed (to match the structure)
        const wrapper = document.createElement('div');
        wrapper.className = 'timer-code__wrapper';
        wrapper.style.display = 'flex';
        wrapper.style.justifyContent = 'flex-end';
        wrapper.style.alignItems = 'center';
        wrapper.style.marginTop = '24px';
        wrapper.appendChild(copyCodesClone);

        // Find the last description-bullet__wrapper element
        const descriptionBullets = this.modalContent.querySelectorAll('.description-bullet__wrapper');
        const lastDescriptionBullet = descriptionBullets.length > 0 ? descriptionBullets[descriptionBullets.length - 1] : null;
        
        // Find the variants select element
        const variantPicker = this.modalContent.querySelector('.product-form__input--dropdown') ||
                              this.modalContent.querySelector('[class*="variant-picker"]') ||
                              this.modalContent.querySelector('[class*="variant__picker"]') ||
                              this.modalContent.querySelector('variant-picker') ||
                              this.modalContent.querySelector('product-variant-picker') ||
                              this.modalContent.querySelector('.product-form__input-wrapper') ||
                              this.modalContent.querySelector('select[name="id"]');
        
        if (lastDescriptionBullet && lastDescriptionBullet.parentNode) {
          // Insert after the last description-bullet__wrapper
          lastDescriptionBullet.parentNode.insertBefore(wrapper, lastDescriptionBullet.nextSibling);
        } else if (variantPicker && variantPicker.parentNode) {
          // If no description bullets found, insert before variant picker
          variantPicker.parentNode.insertBefore(wrapper, variantPicker);
        } else {
          // Fallback: find buy buttons and insert after it
          const buyButtons = this.modalContent.querySelector('.product__buy-buttons') || 
                            this.modalContent.querySelector('[class*="buy-buttons"]');
          
          if (buyButtons && buyButtons.parentNode) {
            buyButtons.parentNode.insertBefore(wrapper, buyButtons.nextSibling);
          } else {
            // Last fallback: append to modal content
            this.modalContent.appendChild(wrapper);
          }
        }

        // Reinitialize copy-codes custom element
        if (window.customElements && customElements.get('copy-codes')) {
          // The custom element should auto-initialize when added to DOM
          // But we can force upgrade if needed
          if (!copyCodesClone.matches(':defined')) {
            customElements.upgrade(copyCodesClone);
          }
        }
      }

      addAdditionalSections(responseHTML) {
        if (!this.modalContent || !responseHTML) return;

        const additionalSections = responseHTML.querySelectorAll('.hp-faq');
        additionalSections.forEach((section) => {
          if (section.closest('product-info')) return;
          const sectionClone = section.cloneNode(true);
          this.modalContent.appendChild(sectionClone);
        });
      }
    }
      );
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductImageModal);
  } else {
    initProductImageModal();
  }
})();

